import { Select } from '../../../components'
import { FormCategoryItem } from '../constants/types'

interface Props {
  currentCategory: string | null
  setCurrentCategory: (category: string | null) => void
  items?: FormCategoryItem[]
}

export function FormCategoryFilter({ currentCategory, setCurrentCategory, items }: Props) {
  return (
    <Select
      data-testid="filing-form-type-select"
      aria-label="Form category"
      className="w-48"
      value={currentCategory}
      items={items}
      contentClass="truncate"
      nativeSelect="mobile"
      onChange={(item) => setCurrentCategory(item.value)}
      comboBox={false}
    />
  )
}
